import React from "react";
import { Box, useTheme } from "@mui/material";
import CounterDotsCst from "./CounterDotsCst";

interface ContentActionsBarCstProps {
  isEmpty: boolean;
  counters?: string[];
  children: React.ReactNode;
}

const ContentActionsBarCst: React.FC<ContentActionsBarCstProps> = ({
  isEmpty,
  counters = [],
  children,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: isEmpty ? "center" : "space-between",
        flexWrap: "wrap",
        gap: 1.5,
        ...(isEmpty && {
          padding: "48px 16px",
          borderRadius: "12px",
          backgroundColor: theme.palette.background.card || "#2A2A2A",
        }),
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          flexWrap: "wrap",
        }}
      >
        {children}
      </Box>

      {!isEmpty && counters.length > 0 && (
        <CounterDotsCst counters={counters} />
      )}
    </Box>
  );
};

export default ContentActionsBarCst;
